<!-- TEMPLATE -->
<template>
  <div class="dean-input-select-multi">
    <div class="row">
      <div class="small-12 medium-12 large-12 hd-12 columns">
        <div class="field">
          <dean-input-field
            :id="id"
            @input="inputChanged"
            :value="input"
            @focus="focusChanged"
          >
            {{ title }}
          </dean-input-field>
          <div class="add">
            <div class="add-inner" @click="addItem">
              <dean-icon class="add-inner-icon" :glyph="plusIcon"> </dean-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="small-12 medium-12 large-12 hd-12 columns">
        <transition-group class="selected-container" name="fade">
          <span class="selected-item" v-for="(item, key) in value" :key="'item-' + key">
            <span class="selected-item-text">{{ item }}</span>
            <dean-icon
              @click.native="removeItem(item)"
              class="selected-item-close"
              :glyph="closeIcon"
            >
            </dean-icon>
          </span>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

// SVG
import goToIcon from '../svg/feather-icons/corner-up-right.svg';
import closeIcon from '../svg/feather-icons/x.svg';
import plusIcon from '../svg/feather-icons/plus.svg';

import deanInputField from './deanInputField.vue';
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanInputField,
    deanIcon
  }
})
export default class deanInputFieldMulti extends Vue {
  // PROPS
  @Prop({
    default: () => {
      return [];
    }
  })
  selected!: Array<any>;
  @Prop({ default: '' }) title!: string;
  @Prop({ default: 'deanInputMultiSelect' }) id!: string;

  // DATA
  closeIcon: object = closeIcon;
  plusIcon: object = plusIcon;
  input: string = '';
  focus: boolean = false;
  value: Array<any> = [];

  // WATCH
  @Watch('selected')
  mapSelected() {
    for (let item in this.selected) {
      this.value.push(this.selected[item]);
    }
    console.log(this.value);
  }

  // METHODS
  inputChanged(input: string) {
    this.input = input;
  }

  addItem() {
    if (this.input != '' || this.input != null || this.input != undefined) {
      this.value.push(this.input);
      this.$emit('selected', this.value);
      this.input = '';
    }
  }

  removeItem(item: string) {
    let index = this.value.indexOf(item);
    if (index > -1) {
      this.value.splice(index, 1);
    }
    console.log(this.value);
    this.$emit('selected', this.value);
  }

  focusChanged(focus: boolean) {
    this.focus = focus;
  }

  keyPressListener(event: { [key: string]: any }) {
    if (this.focus) {
      if (event.keyCode == 13) {
        this.addItem();
      }
    }
  }

  created() {
    this.mapSelected();
    window.addEventListener('keypress', this.keyPressListener);
  }

  destroyed() {
    window.removeEventListener('keypress', this.keyPressListener);
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN WIDGET
.dean-input-select-multi {
  position: relative;

  .field {
    @include display-flex();
    justify-content: space-between;
    width: 100%;
  }

  .add {
    padding: 5px 10px 5px 0px;

    .add-inner {
      height: 40px;
      width: 40px;
      padding: 13.3333px;
      background: var(--color-light-shade-2, $color-light-shade-2);
      fill: var(--color-link, $color-link);
      @include border-radius(10px);
      cursor: pointer;
      transition: 0.8s;

      &:hover {
        fill: var(--color-link-shade-2, $color-link-shade-2);
        background: var(--color-light, $color-light);
      }

      .add-inner-icon {
        height: 13.3333px;
        width: 13.3333px;
      }
    }
  }

  .selected-container {
    @include display-flex();
    justify-content: flex-start;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 5px;

    .selected-item {
      @include display-flex();
      justify-content: flex-start;
      padding: 11px 10px 11px 20px;
      margin: 5px;
      @include border-radius(100px);
      color: black;
      background: var(--color-light-shade-2, $color-light-shade-2);
      word-break: break-all;

      .selected-item-text {
        padding-right: 10px;
      }

      .selected-item-close {
        fill: var(--color-dark-shade-4, $color-dark-shade-4);
        padding: 2px;
        min-height: 18px;
        height: 18px;
        min-width: 18px;
        width: 18px;
        cursor: pointer;
        transition: 0.5s;
        &:hover {
          fill: var(--color-link, $color-link);
        }
      }
    }
  }
}
</style>
